// src/redux/themeSlice.js

import { createSlice } from "@reduxjs/toolkit";

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    theme: "light",
    currentTheme: {
      colorBgBase: "#ffffff",
      colorPrimary: "#F56530",
      colorInfo: "#F56530",
      colorLink: "#ea580c",
      colorTextBase: "#000000",
      colorSuccess: "#16a34a",
      colorWarning: "#ca8a04",
      colorError: "#dc2626",
      colorBgHeader: "red",
    },
  },
  reducers: {
    setCurrentTheme: (state, action) => {
      state.currentTheme = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const { setCurrentTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
